import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Fragment } from "vue-fragment";
import { mapGetters, mapState, mapActions } from "vuex";
import { mapFields } from "@joandvgv/vuex-map-fields";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import LenderSubmitMixin from "@Broker/@Modules/clients/applications/application/select-options/lender-submit-mixin";
import { CURRENT_APPLICATION, CURRENT_APPLICATION_PRINCIPAL_BORROWER, CURRENT_TOTAL_LOAN_AMOUNT } from "../../../store/application-getters";
import { RESET_DEAL_TYPE } from "../../../store/application-actions";
import vSelectField from "@Shared/components/form-elements/fields/v-select-field.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DirectToLenderApplicationSummary",
  components: {
    Fragment,
    MaterialInput,
    vSelectField
  },
  mixins: [validationMixin, LenderSubmitMixin],
  props: {
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  validations: {
    dealType: {
      required
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("ApplicationStore", ["calculatedValues"])), mapFields("ApplicationStore", ["lenderSubmissionData.dealType"])), mapGetters("ApplicationStore", [CURRENT_APPLICATION_PRINCIPAL_BORROWER, CURRENT_TOTAL_LOAN_AMOUNT, CURRENT_APPLICATION])), {}, {
    dealTypeLabel() {
      var _context;
      const {
        label = ""
      } = _findInstanceProperty(_context = this.applicationTypeOptions).call(_context, ({
        value
      }) => value === this.dealType) || {};
      return label;
    },
    principalBorrower() {
      return this.CURRENT_APPLICATION_PRINCIPAL_BORROWER;
    },
    applicationStatusText() {
      return this.$t("application.status")[this.CURRENT_APPLICATION.applicationStatus];
    },
    applicationFlowText() {
      return this.$t("application.flow")[this.CURRENT_APPLICATION.flow];
    },
    applicationStatusDate() {
      return this.CURRENT_APPLICATION.applicationStatusDate;
    },
    closingDate() {
      return this.CURRENT_APPLICATION["mortgage-details"]["mortgage-details"]["closing-date"];
    },
    propertyData() {
      return this.CURRENT_APPLICATION.property.details;
    },
    purchasePrice() {
      return this.propertyData["purchase-price"];
    },
    propertyValue() {
      const propertyValueParser = {
        A: "appraised-value",
        E: "estimated-value",
        P: "purchase-price"
      };
      const {
        "property-value-index": propertyValueIndex
      } = this.propertyData;
      const valueToUse = propertyValueParser[propertyValueIndex];
      return this.propertyData[valueToUse];
    },
    totalLoanAmount() {
      return this.CURRENT_TOTAL_LOAN_AMOUNT;
    }
  }),
  deactivated() {
    this.resetDealType();
  },
  mounted() {
    this.$v.$touch();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ApplicationStore", [RESET_DEAL_TYPE])), {}, {
    resetDealType() {
      this.RESET_DEAL_TYPE();
    }
  })
});